import NOTES_TYPES from "../types/notesTypes";

const initialState = {
    entityNotesResp: undefined,
    createNoteResp: undefined,
    userNotesResp: undefined,
    updateNoteResp: undefined,
    deleteNoteResp: undefined,
    error: undefined
};

export default function notesReducer(state = initialState, action) {
    switch (action.type) {
        case NOTES_TYPES.FETCH_NOTES_BY_ENTITY_SUCCESS: return {
            ...state,
            entityNotesResp: action.payload.data,
            error: undefined
        }
        case NOTES_TYPES.CREATE_NOTE_SUCCESS: return {
            ...state,
            createNoteResp: action.payload.data,
            error: undefined
        }
        case NOTES_TYPES.FETCH_USER_NOTES_SUCCESS: return {
            ...state,
            userNotesResp: action.payload.data,
            error: undefined
        }
        case NOTES_TYPES.UPDATE_NOTE_SUCCESS: return {
            ...state,
            updateNoteResp: action.payload.data,
            error: undefined
        }
        case NOTES_TYPES.DELETE_NOTE_SUCCESS: return {
            ...state,
            deleteNoteResp: action.payload.data,
            error: undefined
        }
        case NOTES_TYPES.CLEAR_NOTE_RESPONSE: return {
            ...state,
            entityNotesResp: undefined,
            createNoteResp: undefined,
            userNotesResp: undefined,
            updateNoteResp: undefined,
            deleteNoteResp: undefined,
            error: undefined
        }
        case NOTES_TYPES.FETCH_NOTES_BY_ENTITY_FAILURE:
        case NOTES_TYPES.CREATE_NOTE_FAILURE:
        case NOTES_TYPES.FETCH_USER_NOTES_FAILURE:
        case NOTES_TYPES.UPDATE_NOTE_SUCCESS:
        case NOTES_TYPES.DELETE_NOTE_SUCCESS: return {
            ...state,
            entityNotesResp: undefined,
            createNoteResp: undefined,
            userNotesResp: undefined,
            updateNoteResp: undefined,
            deleteNoteResp: undefined,
            error: action.payload.error
        }
        default:
            return state;
    }
}
